import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Card, Space, Typography } from 'antd';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import { DeleteForeverRounded, FileCopyRounded, SaveRounded, EditNoteRounded } from "@mui/icons-material";
import { updateResponseById, removeResponseById } from '../Store/slices/gpt.slice';
import MarkdownIt from 'markdown-it';
import MdEditor from 'react-markdown-editor-lite';
import 'react-markdown-editor-lite/lib/index.css';
import TimeCell from "./TimeCell";

const EditableResponse = ({ response }) => {
    const dispatch = useDispatch();
    const [editableContent, setEditableContent] = useState('');
    const [isEditing, setIsEditing] = useState(false);  // Initialize with view-only mode

    useEffect(() => {
        setEditableContent(response.data);
    }, [response]);

    const handleRemoveClick = () => {
        dispatch(removeResponseById(response.id));
    };

    const handleCopyClick = () => {
        navigator.clipboard.writeText(editableContent)
          .then(() => {
            console.log('Response copied to clipboard');
          })
          .catch((error) => {
            console.error('Failed to copy response: ', error);
          });
    };

    const handleSaveClick = () => {
        dispatch(updateResponseById({ id: response.id, data: editableContent }));
        setIsEditing(false);  // Switch back to view-only mode after saving
    };

    const handleEditClick = () => {
        setIsEditing(true);  // Switch to edit mode when the user clicks edit
    };

    const mdParser = new MarkdownIt({
        html: true, // Enable HTML tags in source
        linkify: true, // Autoconvert URL-like text to links
        typographer: true // Enable some smart replacements
    });

    return (
        <Card
            bordered={false}
            style={{
                background: 'transparent',
            }}
            title={
                <Space direction={'vertical'} size={'large'}>
                    <ButtonGroup size={'small'} variant={'outlined'}>
                        <Button color={'error'} onClick={handleRemoveClick} startIcon={<DeleteForeverRounded fontSize={'small'}/>}>
                            Delete
                        </Button>
                        <Button color={'primary'} onClick={handleCopyClick} startIcon={<FileCopyRounded fontSize={'small'}/>}>
                            Copy
                        </Button>
                        {isEditing ? (
                            <Button color={'primary'} onClick={handleSaveClick} startIcon={<SaveRounded fontSize={'small'}/>}>
                                Save
                            </Button>
                        ) : (
                            <Button color={'primary'} onClick={handleEditClick} startIcon={<EditNoteRounded fontSize={'small'}/>}>
                                Edit
                            </Button>
                        )}
                    </ButtonGroup>
                    <Typography.Title>{new Date(response.timestamp).getDate()}</Typography.Title>

                </Space>
            }
        >
            <div style={{ width: '100%', maxWidth: isEditing?'100%':'800px' }}>
                <MdEditor
                    key={isEditing ? 'editing' : 'viewing'}  // Change key to force re-render
                    value={editableContent}
                    style={{ height: '800px' }}
                    renderHTML={(text) => mdParser.render(text)}
                    onChange={({ text }) => setEditableContent(text)}
                    view={{
                        menu: isEditing, // Toggle menu visibility based on editing mode
                        md: isEditing,   // Toggle markdown view for editing mode
                        html: true       // Always show HTML view
                    }}
                    readOnly={!isEditing}  // Ensure the editor itself is read-only when not in editing mode
                />
            </div>
        </Card>
    );
};

export default EditableResponse;
